import './floorplan.scss';

import './img/M-2-korrus_-1.svg';
import './img/M-2-korrus_1.svg';
import './img/M-2-korrus_2.svg';
import './img/M-2-korrus_3.svg';
import './img/M-2-korrus_4.svg';

import './img/UV-3-korrus_1.svg';
import './img/UV-3-korrus_2.svg';
import './img/UV-3-korrus_3.svg';

import './img/UV-61-korrus_1.svg';
import './img/UV-61-korrus_2.svg';
import './img/UV-61-korrus_3.svg';
import './img/UV-61-korrus_4.svg';

import './img/UV-62-korrus_1.svg';
import './img/UV-62-korrus_2.svg';
import './img/UV-62-korrus_3.svg';
import './img/UV-62-korrus_4.svg';
import './img/UV-62-korrus_5.svg';
import './img/UV-62-korrus_6.svg';

import './img/UV-63-korrus_1.svg';
import './img/UV-63-korrus_2.svg';
import './img/UV-63-korrus_3.svg';
import './img/UV-63-korrus_4.svg';
import './img/UV-63-korrus_5.svg';

import './img/UV-7-korrus_1.svg';
import './img/UV-7-korrus_2.svg';
import './img/UV-7-korrus_3.svg';
import './img/UV-7-korrus_4.svg';

import './img/UV-8-1-korrus_1.svg';
import './img/UV-8-1-korrus_2.svg';
import './img/UV-8-1-korrus_3.svg';
import './img/UV-8-1-korrus_4.svg';

import './img/UV-8-2-korrus_1.svg';
import './img/UV-8-2-korrus_2.svg';
import './img/UV-8-2-korrus_3.svg';
import './img/UV-8-2-korrus_4.svg';
import './img/UV-8-2-korrus_5.svg';
import './img/UV-8-2-korrus_6.svg';

import './img/UV-8-3-korrus_1.svg';
import './img/UV-8-3-korrus_2.svg';
import './img/UV-8-3-korrus_3.svg';
import './img/UV-8-3-korrus_4.svg';
import './img/UV-8-3-korrus_5.svg';

import './img/UV-12-3-korrus_1.svg';
import './img/UV-12-3-korrus_2.svg';
import './img/UV-12-3-korrus_3.svg';
import './img/UV-12-3-korrus_4.svg';
import './img/UV-12-3-korrus_5.svg';

import './img/UV-12-2-korrus_1.svg';
import './img/UV-12-2-korrus_1-2.svg';
import './img/UV-12-2-korrus_2.svg';
import './img/UV-12-2-korrus_2-2.svg';
import './img/UV-12-2-korrus_3.svg';
import './img/UV-12-2-korrus_3-2.svg';
import './img/UV-12-2-korrus_4.svg';

import './img/UV-12-1-korrus_1.svg';
import './img/UV-12-1-korrus_2.svg';
import './img/UV-12-1-korrus_3.svg';
import './img/UV-12-1-korrus_4.svg';

import './img/UV-10-1-korrus_1.svg';
import './img/UV-10-1-korrus_2.svg';
import './img/UV-10-1-korrus_3.svg';
import './img/UV-10-1-korrus_4.svg';

import './img/UV-10-2-korrus_1.svg';
import './img/UV-10-2-korrus_2.svg';
import './img/UV-10-2-korrus_3.svg';
import './img/UV-10-2-korrus_4.svg';
import './img/UV-10-2-korrus_5.svg';
import './img/UV-10-2-korrus_6.svg';

import './img/UV-10-3-korrus_1.svg';
import './img/UV-10-3-korrus_2.svg';
import './img/UV-10-3-korrus_3.svg';
import './img/UV-10-3-korrus_4.svg';
import './img/UV-10-3-korrus_5.svg';

import './img/LK_1.svg';
import './img/LK_2.svg';
import './img/LK_3.svg';

import './img/LB_1.svg';
import './img/LB_2.svg';
import './img/LB_3.svg';

import './img/M-7-1-korrus_1.svg';
import './img/M-7-1-korrus_2.svg';
import './img/M-7-1-korrus_3.svg';
import './img/M-7-1-korrus_4.svg';

import './img/M-7-2-korrus_1.svg';
import './img/M-7-2-korrus_1-2.svg';
import './img/M-7-2-korrus_2.svg';
import './img/M-7-2-korrus_2-2.svg';
import './img/M-7-2-korrus_3.svg';
import './img/M-7-2-korrus_3-2.svg';
import './img/M-7-2-korrus_4.svg';

import './img/M-7-3-korrus_1.svg';
import './img/M-7-3-korrus_2.svg';
import './img/M-7-3-korrus_3.svg';
import './img/M-7-3-korrus_4.svg';
import './img/M-7-3-korrus_5.svg';

import './img/T-47-korrus_1.svg';
import './img/T-47-korrus_2.svg';
import './img/T-47-korrus_3.svg';

// pngs for pdf

import './img/UV-12-3-korrus_1.png';
import './img/UV-12-3-korrus_2.png';
import './img/UV-12-3-korrus_3.png';
import './img/UV-12-3-korrus_4.png';
import './img/UV-12-3-korrus_5.png';

import './img/UV-12-2-korrus_1.png';
import './img/UV-12-2-korrus_1-2.png';
import './img/UV-12-2-korrus_2.png';
import './img/UV-12-2-korrus_2-2.png';
import './img/UV-12-2-korrus_3.png';
import './img/UV-12-2-korrus_3-2.png';
import './img/UV-12-2-korrus_4.png';

import './img/UV-12-1-korrus_1.png';
import './img/UV-12-1-korrus_2.png';
import './img/UV-12-1-korrus_3.png';
import './img/UV-12-1-korrus_4.png';

import './img/UV-10-1-korrus_1.png';
import './img/UV-10-1-korrus_2.png';
import './img/UV-10-1-korrus_3.png';
import './img/UV-10-1-korrus_4.png';

import './img/UV-10-2-korrus_1.png';
import './img/UV-10-2-korrus_2.png';
import './img/UV-10-2-korrus_3.png';
import './img/UV-10-2-korrus_4.png';
import './img/UV-10-2-korrus_5.png';
import './img/UV-10-2-korrus_6.png';

import './img/UV-10-3-korrus_1.png';
import './img/UV-10-3-korrus_2.png';
import './img/UV-10-3-korrus_3.png';
import './img/UV-10-3-korrus_4.png';
import './img/UV-10-3-korrus_5.png';

import './img/LK_1.png';
import './img/LK_2.png';
import './img/LK_3.png';

import './img/LB_1.png';
import './img/LB_2.png';
import './img/LB_3.png';

import './img/M-7-1-korrus_1.png';
import './img/M-7-1-korrus_2.png';
import './img/M-7-1-korrus_3.png';
import './img/M-7-1-korrus_4.png';

import './img/M-7-2-korrus_1.png';
import './img/M-7-2-korrus_1-2.png';
import './img/M-7-2-korrus_2.png';
import './img/M-7-2-korrus_2-2.png';
import './img/M-7-2-korrus_3.png';
import './img/M-7-2-korrus_3-2.png';
import './img/M-7-2-korrus_4.png';

import './img/M-7-3-korrus_1.png';
import './img/M-7-3-korrus_2.png';
import './img/M-7-3-korrus_3.png';
import './img/M-7-3-korrus_4.png';
import './img/M-7-3-korrus_5.png';

import './img/T-47-korrus_1.png';
import './img/T-47-korrus_2.png';
import './img/T-47-korrus_3.png';

import Component from '../component/component';

export default class Floorplan extends Component {
    static initSelector: string = '.floorplan';

    overlay: JQuery;
    label: JQuery;

    constructor(target: HTMLElement) {
        super(target);

        this.overlay = this.element.find('.floorplan__overlay');
        this.label = this.element.find('.floorplan__label');

        this.init();
    }

    init(): void {
        this.findSoldItems();

        this.overlay.on('mouseenter', this.onHoverHandler.bind(this));
        this.overlay.on('mouseleave', this.offHoverHandler.bind(this));
    }

    findSoldItems(): void {
        this.overlay.each((index: number, element: HTMLElement) => {
            const target: JQuery = $(element);

            if (target.hasClass('is-sold')) {
                const targetName: string = target.data('id');
                const specificTargetLabel: JQuery = target.closest('.floorplan').find(`.floorplan__label[data-name="${targetName}"]`);

                if (specificTargetLabel.length) {
                    specificTargetLabel.addClass('is-sold');
                } else {
                    const targetLabel: JQuery = $(`#floorplan-label-${targetName}`);

                    targetLabel.addClass('is-sold');
                }
            }
        });
    }

    onHoverHandler(event: JQuery.TriggeredEvent): void {
        const target: JQuery = $(event.currentTarget);

        if (!target.hasClass('is-sold')) {
            const targetName: string = target.data('id');
            const specificTargetLabel: JQuery = target.closest('.floorplan').find(`.floorplan__label[data-name="${targetName}"]`);

            if (specificTargetLabel.length) {
                specificTargetLabel.addClass('is-hovered');
            } else {
                const targetLabel: JQuery = $(`#floorplan-label-${targetName}`);

                targetLabel.addClass('is-hovered');
            }
        }
    }

    offHoverHandler(event: JQuery.TriggeredEvent): void {
        const target: JQuery = $(event.currentTarget);
        const targetName: string = target.data('id');
        const specificTargetLabel: JQuery = target.closest('.floorplan').find(`.floorplan__label[data-name="${targetName}"]`);

        if (specificTargetLabel.length) {
            specificTargetLabel.removeClass('is-hovered');
        } else {
            const targetLabel: JQuery = $(`#floorplan-label-${targetName}`);

            targetLabel.removeClass('is-hovered');
        }
    }
}

